import {createActions} from 'redux-actions';
import FormData from 'form-data';

import {instanceGusaBackend} from 'libs/api';
import {ENDPOINTS} from 'constants/endpoints';

export const {
    cart: {fetchAccessories, addAccessory},
} = createActions({
    CART: {
        /**
         * Fetch accessories data by window accessories ids
         * @param {Array<string>} ids - window accessories ids
         * @return {Promise} - response promise
         */
        FETCH_ACCESSORIES: (ids: Array<string>) =>
            instanceGusaBackend({
                method: 'get',
                headers: {'Content-Type': 'multipart/form-data'},
                url: ENDPOINTS.CART_GET_ACCESSORIES,
                params: {ids},
            }),

        /**
         * Add accessory to cart
         * @param {string} id - accessory id
         * @return {Promise} - response promise
         */
        ADD_ACCESSORY: (id: string) => {
            const data = new FormData();
            data.append('product', id);

            return {
                promise: instanceGusaBackend({
                    method: 'post',
                    headers: {'Content-Type': 'multipart/form-data'},
                    url: ENDPOINTS.CART_ADD_ACCESSORY,
                    data,
                }),
                data: id,
            };
        },
    },
});
